import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LoadingSpinner from '../../Helpers/LoadingSpinner';
import useLoginAuth0Handler from '../../Hooks/useLoginAuth0Handler';
import { useHistory } from 'react-router';
import useVerifySessionAuth0 from '../../Hooks/useVerifySessionAuth0';
import { analyzeUrlCallbackAuth0 } from '../../Helpers/Auth0MobileUtils';
import { deleteOriginCookie, getAuth0TokensFromCache, setAuth0TokensCookies } from '../../Helpers/Auth0CookieManager';
import * as storage from '../../Helpers/Auth0StorageManager';
import { useStore } from '../../Store/storeProvider';

const Auth0Callback = () => {
  const { isAuthenticated, error } = useAuth0();
  const [loginAuth0Handler] = useLoginAuth0Handler();
  const history = useHistory();
  const { Config } = useStore();

  const callbackHandler = async (isVerified) => {
    deleteOriginCookie();
    await analyzeUrlCallbackAuth0(window.location);
    if (isAuthenticated && !error) {
      if (isVerified) {
        const { finalRefreshToken, idToken, accessToken } = getAuth0TokensFromCache();
        setAuth0TokensCookies(accessToken, finalRefreshToken, idToken)
        await loginAuth0Handler();
      } else if (isVerified === false) {
        storage.setCallbackEmailVerification(Config.URLCallback)
        history.push("/auth0-emailConfirmation")
      }
    } else {
      history.push("/auth0-login")
    }
  }
  const [isLoadingProcess] = useVerifySessionAuth0(callbackHandler);

  return (
    <div className='callback-view containerSpinner'>
      <LoadingSpinner isLoading={isLoadingProcess}>
      </LoadingSpinner>
    </div>
  );
}

export default Auth0Callback;